const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
  return undefined;
};

const getDomain = () => {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return 'localhost';
  } else if (location.hostname === 'rover.local') {
    return 'rover.local';
  }
  return '.rover.com';
};

const createCookie = (name, value, days) => {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }

  document.cookie = `${name}=${value}${expires}; domain=${getDomain()}; path=/`;
};

const removeCookie = name => {
  if (!getCookie(name)) return;
  document.cookie = `${name}=;path=/;domain=${getDomain()};expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};

const hasCookie = name => !!getCookie(name);

export { getCookie, getDomain, createCookie, removeCookie, hasCookie };



// WEBPACK FOOTER //
// ../utilities/cookie.js